import React, { FC } from "react";

const NotFoundPage: FC = () => <>404</>;

export default NotFoundPage;
